import makeColorScheme from "./make-color-scheme.js";
export { default as makeColorScheme } from "./make-color-scheme.js";
export const defaultColorSchemes = {
    light: makeColorScheme("light", {
        primary: "#3a76b9",
        text: "#1b1b1b",
        background: "#ffffff",
        gray: "#dfe7ed",
        success: "#129614",
        error: "#be4d30",
    }),
    dark: makeColorScheme("dark", {
        primary: "#688c7d",
        text: "#cbd2d4",
        gray: "#858b8c",
        background: "#41464f",
        success: "#57bc81",
        error: "#df6f67",
    }),
};
//# sourceMappingURL=index.js.map